








import {Component, Vue} from 'vue-property-decorator';
import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from './pbi-dict-workspace-id';

@Component({
  name: 'PbiMarketDiagnosisFordDealerGroupPage',
  components: { ReportPowerBiContainer }
})
export default class PbiMarketDiagnosisFordDealerGroupPage extends Vue {
  private pbiDictWorkspaceId = new PbiDictWorkspaceId();

  public crrReport = {
    reportId: '6d01ba1e-cb51-4fa6-b0ed-ba230d8656f6',
    workspaceId: this.pbiDictWorkspaceId.dictionary[PbiWorkspacesEnum.Neodash]
  }
}
